import useSWR from 'swr'
import fetcher from './fetcher'

export default function useInsiderTradings(id, { openMarketOnly = false } = {}) {
  const query = openMarketOnly ? '&open_market=1' : ''
  const { data, error, isLoading } = useSWR(`/react/insider-tradings?stock_id=${id}${query}`, fetcher, {
    keepPreviousData: true,
  })

  return {
    insiderTradings: data,
    isLoading,
    error
  }
}
